import { mixed, string } from "yup";
import i18next from "utilities/i18n";
import { TypeCheck } from "./TypeCheck";
import { urlValidateB64 } from "utilities/base64Utils";

const isValidBase64UrlString = (value: string): boolean => {
  return urlValidateB64(value.replace(/\s/g, ""));
};
export type Base64UrlStringFieldType = "base64UrlString";
const type: Base64UrlStringFieldType = "base64UrlString";

export class base64UrlStringField extends string implements TypeCheck {
  constructor() {
    super();
    // @ts-ignore
    mixed.call(this, { type });
  }

  _typeCheck(value: string) {
    return isValidBase64UrlString(value);
  }
}

export const base64UrlString = (
  typeErrorMessage?: string
): base64UrlStringField =>
  new base64UrlStringField().typeError(
    typeErrorMessage ?? i18next.t("ERROR_INVALID_BASE64_URL_STRING")
  );
